<template>
  <Form :ref="'form'+current" :model="form" :rules="rules" :label-width="165">
    <Divider orientation="left">同住配偶信息</Divider>
    <Row :gutter="16">
      <Col span="24">
      <Alert show-icon closable>请填写申请人的同住配偶信息</Alert>
      </Col>
      <Col span="12">
      <FormItem label="上传配偶身份证人像面" prop="idCardFrontGuid">
        <Row :gutter="16">
          <Col span="24">
          <div class="line_area">
            <div>
              <Upload multiple type="drag" class="uploadImage" :max-size="5120" :on-exceeded-size="handleMaxSize" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'idCardFrontGuidProgress')" :accept="accept"
                :format='format' :show-upload-list='false' :data="uploadData" :on-success="(response, file, fileList)=>{$refs['idCardFrontGuidProgress'].updateShow(false)
        $refs['idCardFrontGuidProgressUpload'].style.display = 'block';handleSuccess(response, file, fileList,'idCardFrontGuid',false,'spouseIdCard',[{name:'name',},{idCard:'idCardNo'}])}" :on-format-error="handleFormatError"
                :action="$baseURL+'/common/file/uploadfile'">
                <div class="uploadBg">
                  <span ref="idCardFrontGuidProgressUpload">
                    <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                    <div class="upload_btn">
                      <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                    </div>
                    <div class="upload_btn" @click.stop="openQrCodeUpload('idCardFrontGuid',false,'spouseIdCard',[{name:'name',},{idCard:'idCardNo'}])">
                      <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                    </div>
                  </span>
                  <progress-bar ref="idCardFrontGuidProgress"></progress-bar>

                </div>
              </Upload>
            </div>
            <!-- 已上传图片 -->
            <div class="fileList" v-if="form.idCardFrontGuid">
              <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
              <span class="pos">
                <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ form.idCardFrontGuid" />
                <i class="img_magnify">
                  <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.idCardFrontGuid)" type="ios-eye" />
                  <Icon size="26" class="ico" color="#ffffff" @click="handleRemove(0,form.idCardFrontGuid,'idCardFrontGuid')" type="ios-trash-outline" />
                </i>
              </span>
              <!-- </template> -->
            </div>
            <div class="fileList" v-else>
              <span class="pos">
                <span class="img">
                  <span class="uploadImageNo">
                    <Icon type="ios-image" size="30" />
                  </span>
                </span>
              </span>
            </div>
          </div>
          </Col>
        </Row>
      </FormItem>
      </Col>
      <Col span="12">
      <FormItem label="上传配偶身份证国徽面" prop="idCardBackGuid">
        <Row :gutter="16">
          <Col span="24">
          <div class="line_area">
            <Upload multiple type="drag" class="uploadImage" :data="{readIdbackAfterUploaded: true}" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'idCardBackGuidProgress')" :accept="accept" :format='format'
              :show-upload-list='false' :on-success="(response, file, fileList)=>{$refs['idCardBackGuidProgress'].updateShow(false)
        $refs['idCardBackGuidProgressUpload'].style.display = 'block';handleSuccess(response, file, fileList,'idCardBackGuid',false,'idcard_back')}" :on-format-error="handleFormatError" :action="$baseURL+'/common/file/uploadfile'">
              <div class="uploadBg">
                <span ref="idCardBackGuidProgressUpload">
                  <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                  <div class="upload_btn">
                    <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                  </div>
                  <div class="upload_btn" @click.stop="openQrCodeUpload('idCardBackGuid',false,'idcard_back')">
                    <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                  </div>
                </span>
                <progress-bar ref="idCardBackGuidProgress"></progress-bar>

              </div>
            </Upload>
            <!-- 已上传图片 -->
            <div class="fileList" v-if="form.idCardBackGuid">
              <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
              <span class="pos">
                <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ form.idCardBackGuid" />
                <i class="img_magnify">
                  <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.idCardBackGuid)" type="ios-eye" />
                  <Icon size="26" class="ico" color="#ffffff" @click="handleRemove(0,form.idCardBackGuid,'idCardBackGuid')" type="ios-trash-outline" />

                </i>
              </span>
              <!-- </template> -->
            </div>
            <div class="fileList" v-else>
              <span class="pos">
                <span class="img">
                  <span class="uploadImageNo">
                    <Icon type="ios-image" size="30" />
                  </span>
                </span>
              </span>
            </div>
          </div>
          </Col>
        </Row>
      </FormItem>
      </Col>
      <Col span="12">
      <FormItem label="配偶姓名" prop="name">
        <Input v-model.trim="form.name" disabled :maxlength="40" placeholder="上传身份证人像面自动识别"></Input>
      </FormItem>
      </Col>
      <Col span="12">
      <FormItem label="配偶身份证号" prop="idCardNo">
        <Input v-model.trim="form.idCardNo" disabled :maxlength="40" placeholder="上传身份证人像面自动识别"></Input>
      </FormItem>
      </Col>
      <!-- 非上海户籍并且不随申请人享受待遇时只要传身份证 -->
      <template v-if="form.isSpouseRegisteredResidenceInSH===true||form.isSpouseEnjoyTreatment===true">
        <Col span="24">
        <FormItem label="配偶户籍" prop="registeredResidenceType">
          <RadioGroup v-model.trim="form.registeredResidenceType">
            <Radio :label="value" v-for="{text,value} in $store.state.materiaBasicData.registeredResidenceType" :key="value">{{text}}</Radio>
          </RadioGroup>
        </FormItem>
        </Col>
        <Col span="24" v-if="form.registeredResidenceType===$store.state.registeredResidenceType['集体户口']">
        <FormItem label="集体户口类型" prop="collectiveAccountMaterialsType">
          <RadioGroup v-model.trim="form.collectiveAccountMaterialsType">
            <Radio :label="value" v-for="{text,value} in $store.state.materiaBasicData.collectiveAccountMaterialsTypes" :key="value">{{text}}</Radio>
          </RadioGroup>
        </FormItem>
        </Col>
        <template
          v-if="form.registeredResidenceType===$store.state.registeredResidenceType['家庭户口']||(form.registeredResidenceType===$store.state.registeredResidenceType['集体户口']&&form.collectiveAccountMaterialsType===$store.state.collectiveAccountMaterialsTypes['户口簿'])">
          <Col span="12">
          <FormItem label="上传配偶户口簿详细地址页的首页" prop="residenceBookletMainPageGuid">
            <Row :gutter="16">
              <Col span="24">
              <div class="line_area">
                <Upload multiple type="drag" class="uploadImage" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'residenceBookletMainPageGuidProgress')" :accept="accept" :format='format'
                  :show-upload-list='false' :on-success="(response, file, fileList)=>{$refs['residenceBookletMainPageGuidProgress'].updateShow(false)
        $refs['residenceBookletMainPageGuidProgressUpload'].style.display = 'block';handleSuccess(response, file, fileList,'residenceBookletMainPageGuid')}" :on-format-error="handleFormatError" :action="$baseURL+'/common/file/uploadfile'">
                  <div class="uploadBg">
                    <span ref="residenceBookletMainPageGuidProgressUpload">
                      <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                      <div class="upload_btn">
                        <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                      </div>
                      <div class="upload_btn" @click.stop="openQrCodeUpload('residenceBookletMainPageGuid')">
                        <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                      </div>
                    </span>
                    <progress-bar ref="residenceBookletMainPageGuidProgress"></progress-bar>

                  </div>
                </Upload>
                <!-- 已上传图片 -->
                <div class="fileList" v-if="form.residenceBookletMainPageGuid">
                  <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
                  <span class="pos">
                    <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ form.residenceBookletMainPageGuid" />
                    <i class="img_magnify">
                      <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.residenceBookletMainPageGuid)" type="ios-eye" />

                      <Icon size="26" class="ico" color="#ffffff" @click="handleRemove(0,form.residenceBookletMainPageGuid,'residenceBookletMainPageGuid')" type="ios-trash-outline" />
                    </i>
                  </span>
                  <!-- </template> -->
                </div>
                <div class="fileList" v-else>
                  <span class="pos">
                    <span class="img">
                      <span class="uploadImageNo">
                        <Icon type="ios-image" size="30" />
                      </span>
                    </span>
                  </span>
                </div>
              </div>
              </Col>
            </Row>
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem label="上传配偶户口簿本人信息页" prop="residenceBookletSelfPageGuid">
            <Row :gutter="16">
              <Col span="24">
              <div class="line_area">
                <Upload multiple type="drag" class="uploadImage" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'residenceBookletSelfPageGuidProgress')" :accept="accept" :format='format'
                  :show-upload-list='false' :on-success="(response, file, fileList)=>{$refs['residenceBookletSelfPageGuidProgress'].updateShow(false)
        $refs['residenceBookletSelfPageGuidProgressUpload'].style.display = 'block';handleSuccess(response, file, fileList,'residenceBookletSelfPageGuid')}" :on-format-error="handleFormatError" :action="$baseURL+'/common/file/uploadfile'">
                  <div class="uploadBg">
                    <span ref="residenceBookletSelfPageGuidProgressUpload">
                      <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                      <div class="upload_btn">
                        <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                      </div>
                      <div class="upload_btn" @click.stop="openQrCodeUpload('residenceBookletSelfPageGuid')">
                        <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                      </div>
                    </span>
                    <progress-bar ref="residenceBookletSelfPageGuidProgress"></progress-bar>

                  </div>
                </Upload>
                <div class="fileList" v-if="form.residenceBookletSelfPageGuid">
                  <span class="pos">
                    <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ form.residenceBookletSelfPageGuid" />
                    <i class="img_magnify">
                      <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.residenceBookletSelfPageGuid)" type="ios-eye" />
                      <Icon size="26" class="ico" color="#ffffff" @click="handleRemove(0,form.residenceBookletSelfPageGuid,'residenceBookletSelfPageGuid')" type="ios-trash-outline" />
                    </i>
                  </span>
                </div>
                <div class="fileList" v-else>
                  <span class="pos">
                    <span class="img">
                      <span class="uploadImageNo">
                        <Icon type="ios-image" size="30" />
                      </span>
                    </span>
                  </span>
                </div>
              </div>
              </Col>
            </Row>
          </FormItem>
          </Col>
        </template>
        <template v-if="form.registeredResidenceType===$store.state.registeredResidenceType['集体户口']&&form.collectiveAccountMaterialsType===$store.state.collectiveAccountMaterialsTypes['派出所出具的户籍证明']">
          <Col span="12">
          <FormItem label="派出所出具的户籍证明" prop="policeStationRegistrationCertificateGuid">
            <Row :gutter="16">
              <Col span="24">
              <div class="line_area">
                <Upload multiple type="drag" class="uploadImage" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'policeStationRegistrationCertificateGuidProgress')" :accept="accept" :format='format'
                  :show-upload-list='false' :on-success="(response, file, fileList)=>{$refs['policeStationRegistrationCertificateGuidProgress'].updateShow(false)
        $refs['policeStationRegistrationCertificateGuidProgressUpload'].style.display = 'block';handleSuccess(response, file, fileList,'policeStationRegistrationCertificateGuid')}" :on-format-error="handleFormatError"
                  :action="$baseURL+'/common/file/uploadfile'">
                  <div class="uploadBg">
                    <span ref="policeStationRegistrationCertificateGuidProgressUpload">
                      <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                      <div class="upload_btn">
                        <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                      </div>
                      <div class="upload_btn" @click.stop="openQrCodeUpload('policeStationRegistrationCertificateGuid')">
                        <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                      </div>
                    </span>
                    <progress-bar ref="policeStationRegistrationCertificateGuidProgress"></progress-bar>

                  </div>
                </Upload>
                <!-- 已上传图片 -->
                <div class="fileList" v-if="form.policeStationRegistrationCertificateGuid">
                  <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
                  <span class="pos">
                    <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ form.policeStationRegistrationCertificateGuid" />
                    <i class="img_magnify">
                      <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.policeStationRegistrationCertificateGuid)" type="ios-eye" />

                      <Icon size="26" class="ico" color="#ffffff" @click="handleRemove(0,form.policeStationRegistrationCertificateGuid,'policeStationRegistrationCertificateGuid')" type="ios-trash-outline" />
                    </i>
                  </span>
                  <!-- </template> -->
                </div>
                <div class="fileList" v-else>
                  <span class="pos">
                    <span class="img">
                      <span class="uploadImageNo">
                        <Icon type="ios-image" size="30" />
                      </span>
                    </span>
                  </span>
                </div>
              </div>
              </Col>
            </Row>
          </FormItem>
          </Col>
        </template>
      </template>
      <Col span="12">
      <FormItem label="其他婚姻材料" class="noticeTop">
        <Upload :show-upload-list="false" :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :default-file-list="form.spouseOtherMarriageGuidListPreview" :on-preview="handlePreview"
          :action="$baseURL + '/common/file/uploadfile'" :on-remove="
              (file, fileList) =>
                handleRemove(file, fileList, 'spouseOtherMarriageGuidList',true)
            " :on-success="
              (response, file, fileList) =>
                handleSuccess(response, file, fileList, 'spouseOtherMarriageGuidList',true)
            " :on-format-error="handleFormatError">
          <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
          <Button icon="ios-camera" @click.stop="openQrCodeUpload('spouseOtherMarriageGuidList',true)">手机拍照上传</Button>
        </Upload>

      </FormItem>
      <FormItem class="notice">
        <div>
          请完整提交每段婚姻材料：
          <div>1、离婚：离婚证、离婚协议书或法院调解书、判决书；</div>
          2、丧偶：死亡证明。
        </div>
        <div class="_linkdel" v-for="file in form.spouseOtherMarriageGuidListPreview" :key="file.guid">
          <div class="fileCentent" @click="handlePreview(file)">
            <Icon :type="file.name | fileType" />
            {{file.name?file.name:file.fileName}}
          </div>
          <div class="fileDel">
            <Icon type="md-close" @click="handleRemove(file, null, 'spouseOtherMarriageGuidList',true)" />
          </div>
        </div>
      </FormItem>
      </Col>
    </Row>
    <div class="bom_btn">
      <div>
        <Button @click="next(null,-1)">上一步</Button>
        <Button type="primary" @click="next('form'+current,1)">下一步</Button>
      </div>
    </div>
  </Form>
</template>
<script>
export default {
  props: { form: { type: Object }, current: { type: Number } },

  data() {
    return {
      format: ['jpg', 'png', 'jpeg'],
      accept: 'image/*',
      //   form: { id: 'ywlsh_12356789', kh: '新开户', sfzzm: [] },
      uploadData: { readIdInfo: true },
      appInfoDataType: this.$store.state.appInfoDataType,
      current_index: this.current,
      rules: {
        idCardFrontGuid: [{ required: true, message: '请上传', trigger: 'change' }],
        idCardBackGuid: [{ required: true, message: '请上传', trigger: 'change' }],
        name: [{ required: true, message: '请输入', trigger: 'change' }],
        idCardNo: [
          { required: true, message: '请输入', trigger: 'change' },
          {
            pattern:
              /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
            message: '请输入正确的身份证号',
            trigger: 'blur',
          },
        ],
        registeredResidenceType: [
          { required: true, message: '请选择', type: 'number', trigger: 'change' },
        ],
        residenceBookletMainPageGuid: [{ required: true, message: '请上传', trigger: 'change' }],
        residenceBookletSelfPageGuid: [{ required: true, message: '请上传', trigger: 'change' }],
        marriageCertificateGuid: [{ required: true, message: '请上传', trigger: 'change' }],
      },
      clList: ['rl', 'dw', 'yy', 'sh', 'rl'],
      selectList: [
        { name: '是', value: 1 },
        { name: '否', value: 0 },
      ],
    }
  },
  methods: {
    //下一步
    next(name, val) {
      //上一步
      let _this = this
      let submiteUrl = '/api/services/app/JZZJFApi/SaveAppSpouseInfo'

      if (name == null) {
        this.$emit('next', val, submiteUrl)
        return
      }
      //下一步

      this.$refs[name].validate((valid) => {
        if (!valid) {
          this.$Message.error('请将信息填写完整')
          return
        }

        _this.$emit('next', val, submiteUrl)
      })
    },
    //文件大小超出
    handleMaxSize(file) {
      this.$emit('handleMaxSize', file)
    },
    // submit(name) {
    //   let _this = this
    //   this.$refs[name].validate((valid) => {
    //     if (!valid) {
    //       this.$Message.error('请将信息填写完整')
    //       return
    //     }
    //     this.$Modal.confirm({
    //       title: '请确认',
    //       content: `<p>是否提交信息</p>`,
    //       okText: '是',
    //       cancelText: '否',
    //       onOk: () => {
    //         _this.$emit('submit')
    //       },
    //     })
    //   })
    // },
    //移除文件
    async handleRemove(file, fileList, property, isArray) {
      this.$emit('handleRemove', file, fileList, property, isArray)
    },
    //文件上传成功
    handleSuccess(
      response,
      file,
      fileList,
      property,
      isArray,
      isReadIdInfoAfter,
      readIdInfoAfterToView
    ) {
      this.$emit(
        'handleSuccess',
        response,
        file,
        fileList,
        property,
        isArray,
        isReadIdInfoAfter,
        readIdInfoAfterToView
      )
    },
    openQrCodeUpload(property, isArray, isReadInfo, readIdInfoAfterToView) {
      this.$emit('openQrCodeUpload', property, isArray, isReadInfo, readIdInfoAfterToView)
    },
    //文件格式错误
    handleFormatError(file) {
      this.$emit('handleFormatError', file)
    },
    //文件预览
    handlePreview(file) {
      this.$emit('handlePreview', file)
    },
    //预览
    handleView(guid) {
      this.$emit('handleView', guid)
    },
    //
    updateProgress(event, file, fileList, name) {
      // this.percent = fileInfo.percent * 0.01
      this.$refs[name + 'Upload'].style.display = 'none'
      this.$refs[name].updateShow(true)
      this.$refs[name].updateProgress(Math.round(event.percent)) //=fileInfo.percent * 0.01

      this.$refs[name + 'Upload'].show = event.percent == 100
      // if (event.percent == 100) {
      //   this.$refs[name].updateShow(false)
      //   this.$refs[name + 'Upload'].style.display = 'block'
      // }
    },
  },
}
</script>